import { AudienceParcoursHub } from '../../../components/parcours/AudienceParcoursHub';
import { TRAVAUX_TERTIAIRE } from '../../../config/travaux-tertiaire';

export default function TertiaireTravauxHubPage() {
  return (
    <AudienceParcoursHub
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      items={TRAVAUX_TERTIAIRE}
      heroEyebrow="Plan Décret Tertiaire · 6 travaux éligibles"
      heroHeadline="Vos travaux d'efficacité énergétique"
      heroHeadlineAccent="pour le plan -40 % 2030."
      heroIntro="Pompe à chaleur tertiaire, gestion technique du bâtiment (GTB) classe B, eau chaude sanitaire solaire, isolation toiture-terrasse, relamping LED, calorifugeage : six travaux mobilisables sur votre patrimoine tertiaire d'au moins 1 000 m², financés par des primes CEE, le Coup de pouce chauffage-climatisation et le suramortissement fiscal."
      primaryCta={{ label: "Lancer l'audit Décret Tertiaire", href: '/tertiaire/decret-tertiaire' }}
      secondaryCta={{ label: 'Estimer mes primes CEE tertiaires', href: '/tertiaire/diagnostic-cee' }}
      bullets={['Références officielles citées', "Sans engagement", 'Accord de confidentialité disponible']}
      gridEyebrow="6 opérations standardisées"
      gridTitle="Les travaux structurants de votre trajectoire OPERAT"
      ctaFinalTitle="Construisons votre plan -40 % à 2030"
      ctaFinalDescription="Audit Décret Tertiaire, hiérarchisation des travaux prioritaires, mobilisation des primes CEE et bonifications Coup de pouce, accompagnement en cas de contrôle par l'ADEME."
    />
  );
}
